import { PlusCircleOutlined } from "@ant-design/icons";
import { Button, Card, Col, Divider, Drawer, Flex, Image, Modal, Row, Space } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import icon from "../../../assets/images/bag.svg";
import Logo from "../../../assets/images/mascot.svg";

import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { generateRandomString } from "utils/helper";
import { getCreditRemainder, getProfile } from "../services/webAppApi";
import { setCreditRemainder, setIsLoading, setProfile } from "../slices/webappSlice";
import "../styles/drawer.css";
import styles from "../styles/Product.module.css";

const useProduct = () => {

    const { t, i18n } = useTranslation();
    const location = useLocation();
    const currentPath = location.pathname;

    const h1 = t("becash.label.hello")

    const [open, setOpen] = useState(false);
    const [placement, setPlacement] = useState('bottom');
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    const { profile } = useSelector((state) => state.webapp)
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const HomeIcon = ({ color }) => {
        return (
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.13525 11.6875V16.3646C3.13525 21.0417 5.01025 22.9167 9.68734 22.9167H15.3019C19.979 22.9167 21.854 21.0417 21.854 16.3646V11.6875" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.4999 12.5C14.4062 12.5 15.8124 10.948 15.6249 9.04171L14.9374 2.08337H10.0728L9.37493 9.04171C9.18743 10.948 10.5937 12.5 12.4999 12.5Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19.0728 12.5C21.177 12.5 22.7187 10.7917 22.5103 8.69796L22.2187 5.83337C21.8437 3.12504 20.802 2.08337 18.0728 2.08337H14.8958L15.6249 9.38546C15.802 11.1042 17.3541 12.5 19.0728 12.5Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.87506 12.5C7.59381 12.5 9.14589 11.1042 9.31256 9.38546L9.54173 7.08337L10.0417 2.08337H6.86464C4.13548 2.08337 3.09381 3.12504 2.71881 5.83337L2.43756 8.69796C2.22923 10.7917 3.77089 12.5 5.87506 12.5Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.4999 17.7084C10.7603 17.7084 9.89575 18.573 9.89575 20.3125V22.9167H15.1041V20.3125C15.1041 18.573 14.2395 17.7084 12.4999 17.7084Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    }

    const HistoryIcon = ({ color }) => {
        return (
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.5625 10.875L21.5417 15.2292C20.6667 18.9896 18.9375 20.5104 15.6875 20.1979C15.1667 20.1563 14.6042 20.0625 14 19.9167L12.25 19.5C7.90623 18.4688 6.56248 16.3229 7.58332 11.9688L8.60415 7.6042C8.81248 6.71878 9.06248 5.94795 9.37498 5.31253C10.5937 2.7917 12.6667 2.11461 16.1458 2.93753L17.8854 3.34378C22.25 4.36461 23.5833 6.52086 22.5625 10.875Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.6875 20.1979C15.0417 20.6354 14.2292 21 13.2396 21.3229L11.5937 21.8646C7.45832 23.1979 5.28124 22.0833 3.93749 17.9479L2.60416 13.8333C1.27082 9.69792 2.37499 7.51042 6.51041 6.17708L8.15624 5.63542C8.58332 5.5 8.98957 5.38542 9.37499 5.3125C9.06249 5.94792 8.81249 6.71875 8.60416 7.60417L7.58332 11.9687C6.56249 16.3229 7.90624 18.4687 12.25 19.5L14 19.9167C14.6042 20.0625 15.1667 20.1562 15.6875 20.1979Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.1667 8.88538L18.2188 10.1666" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.1458 12.9166L15.1666 13.6875" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    }

    const MeIcon = ({ color }) => {
        return (
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.6667 11.323C12.5625 11.3125 12.4375 11.3125 12.3229 11.323C9.84375 11.2396 7.875 9.20837 7.875 6.70837C7.875 4.15629 9.9375 2.08337 12.5 2.08337C15.0521 2.08337 17.125 4.15629 17.125 6.70837C17.1146 9.20837 15.1458 11.2396 12.6667 11.323Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.45825 15.1666C4.93742 16.8541 4.93742 19.6041 7.45825 21.2812C10.3228 23.1979 15.0208 23.1979 17.8853 21.2812C20.4062 19.5937 20.4062 16.8437 17.8853 15.1666C15.0312 13.2604 10.3333 13.2604 7.45825 15.1666Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

        )
    }

    const activeColor = (path) => (currentPath === path ? '#FF9401' : '#B5ABAB');


    const menuItems = [
        { key: 'product', label: 'be Cash', icon: HomeIcon, route: '/webapp/product' },
        { key: 'history', label: 'History', icon: HistoryIcon, route: '/webapp/history' },
        { key: 'user', label: 'Me', icon: MeIcon, route: '/webapp/user' },
    ];

    const onClose = () => {
        setOpen(false);
    };

    const serviceProfile = async (params) => {
        try {
            dispatch(setIsLoading(true));
            const response = await getProfile({
                ...params,
                requestId: generateRandomString(),
                productCode: "BE0001",
                page: 0, size: 100
            });
            console.log("data", response?.data?.content);
            dispatch(setProfile(response?.data?.content))
        } catch (error) {
            console.log("error", error);
        } finally {
            dispatch(setIsLoading(false));
        }
    }

    const serviceCreditRemainder = async (params) => {
        try {
            dispatch(setIsLoading(true));
            const response = await getCreditRemainder({
                ...params,
                requestId: generateRandomString(),
                productCode: "BE0001"
            });
            // console.log("response", response);
            console.log("data", response.data);
            dispatch(setCreditRemainder(response.data))
            if (response.data?.status.code == 200) {
                navigate("/webapp/transaction")
            } else {
                Modal.error({ content: response?.data?.status?.description })
            }
        } catch (error) {
            console.log("error", error);
            dispatch(setCreditRemainder({}))
            // alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }

    useEffect(() => {
        serviceProfile()
    }, [])

    const h2 = (i18n.language === "en" ? profile?.nameEn + " " + profile?.surNameEn : "คุณ " + profile?.name + " " + profile?.surName)

    function product() {
        return (
            <Row>
                <Col span={isPortrait ? 2 : 1}>
                    <Image
                        preview={false}
                        width={isPortrait ? "5vw" : "3vw"}
                        src={icon}
                    />
                </Col>
                <Col span={22}>
                    <span style={{ color: "#5E5E5E" }}>ผลิตภัณฑ์ be Cash</span>
                </Col>
            </Row>
        )
    }

    function card() {
        return (
            <Card style={{
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                borderRadius: "1rem",
                backgroundColor: "rgba(255, 255, 255, 0.5)",

            }}
            // bodyStyle={{ padding: "12px" }} // Remove padding here
            >

                <Row>
                    <Col span={1} style={{
                        padding: 0,
                        margin: 0,
                        alignContent: "center",
                        justifyContent: "center",
                        textAlignLast: "center"


                    }}>
                        <Divider type="vertical" className={styles.customDivider} style={{ backgroundColor: "#FF9401", borderRadius: "1vh", width: isPortrait ? "0.4vh" : "0.6vw", height: isPortrait ? "6vh" : "12vh" }} />
                    </Col>
                    <Col span={16} style={{ padding: 0, alignContent: "center" }}>
                        <Flex vertical style={{
                            color: "#959595",
                            fontSize: isPortrait ? "1.8vh" : "2vw",
                        }}>
                            <span>สวัสดิการเบิกเงินล่วงหน้า</span>
                            <span>สำหรับกลุ่มบริษัท ไบรต์ เอ็คซ์เพิร์ท</span>
                        </Flex>
                    </Col>
                    <Col span={7} style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
                        <Image
                            preview={false}
                            width={isPortrait ? "9vh" : "9.5vw"}
                            src={Logo}
                        /></Col>

                </Row>
                <Row style={{ justifyContent: "center", alignContent: "flex-end", height: isPortrait ? "6vh" : "10vh" }}>
                    <Space direction="vertical" style={{ justifyContent: "center", alignContent: "center", }}>
                        <Button onClick={() => { setOpen(true) }} style={{
                            backgroundColor: "#2FD159",
                            color: "white",
                            height: isPortrait ? "4vh" : "8vh"
                            , width: isPortrait ? "30vh" : "40vw",
                            fontSize: isPortrait ? "1.8vh" : "2vw",
                            borderRadius: isPortrait ? "2vh" : "4vw",
                            borderColor: "#2FD159",
                        }}>
                            <PlusCircleOutlined /> <span>สมัครเบิกเงินล่วงหน้า</span>
                        </Button>
                    </Space>
                </Row>

            </Card >
        )
    }
    function navBar() {
        return (
            <Card style={{
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                width: "100%",
                height: isPortrait ? "11vh" : "15vh",
                position: "fixed",
                bottom: 0,
            }}>
                <Row gutter={24} style={{
                    justifyContent: "center",
                    alignContent: "center",
                    height: isPortrait ? "5vh" : "3vh"
                }}>
                    {menuItems.map(item => (
                        <Col key={item.key} span={8} style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
                            <Flex
                                vertical
                                onClick={() => {
                                    navigate(item.route);
                                }}
                                justify="center"
                                align="center"
                            >
                                {item.icon({ color: activeColor(item.route) })}
                                <Flex vertical style={{ height: isPortrait ? "3vh" : "5vh", justifyContent: "flex-end" }}>
                                    <span style={{
                                        fontSize: isPortrait ? "1.5vh" : "3vh",
                                        color: activeColor(item.route)
                                    }}>
                                        {item.label}
                                    </span>
                                </Flex>
                            </Flex>
                        </Col>
                    ))}
                </Row>
            </Card>
        )
    }
    function drawer() {
        return (
            <Drawer
                // title={<span>be Cash</span>}
                height={isPortrait ? "60vh" : "40vw"}
                placement="bottom"
                closable={false}
                onClose={onClose}
                open={open}
                key={placement}
                styles={{
                    content: {
                        background: 'transparent',
                    },
                    body: {
                        background: 'white',
                        borderTopLeftRadius: "8vh", borderTopRightRadius: "8vh"
                    }
                }}
            >


                <Flex vertical style={{ padding: "4vh", height: "100%" }}>

                    <Row>
                        <Col span={18} style={{ padding: 0, alignSelf: "center" }}>
                            <Flex vertical style={{ fontWeight: "bolder", color: "#646464", fontSize: isPortrait ? "3vh" : "2.5vw", height: isPortrait ? "6vh" : "8vh" }}>
                                <span>be Cash</span>
                            </Flex>
                            <Flex vertical style={{ color: "#959595", fontSize: isPortrait ? "1.8vh" : "1.8vw" }}>
                                <span>be Cash เบิกเงินสดล่วงหน้า</span>
                                <span>สำหรับกลุ่มบริษัท ไบรต์ เอ็คซ์เพิร์ท</span>
                            </Flex>
                        </Col>
                        <Col span={6} style={{ textAlignLast: "center" }}>
                            <Image
                                preview={false}
                                width={isPortrait ? "10vh" : "10vw"}
                                src={Logo}
                            /></Col>
                        <Row>
                            <span style={{
                                fontSize: isPortrait ? "1.8vh" : "1.8vw", color: "#959595", textAlign: "justify", wordSpacing: "normal",
                                letterSpacing: "normal", lineHeight: "1.5", height: "30vh", justifyContent: "flex-end", alignContent: "center"
                            }}>
                                บริการเบิกเงินเดือนล่วงหน้าเพื่อพนักงานได้รับเงินรวดเร็วทันเวลาแก้ไขปัญหาได้ทันท่วงทีไม่สร้างภาระดอกเบี้ยหรือหนี้สินที่ไม่จำเป็นวยบรรเทาภาระค่าใช้จ่ายของพนักงานองค์กรไม่ต้องยุ่งยากกับการบริหารเงินและไม่ต้องสำรองเงินล่วงหน้าเพื่อช่วยเหลือพนักงานสมัครสมาชิกดำเนินการและขออนุมัติง่ายสะดวกสบายผ่านสมาร์ทโฟนและระบบออนไลน์ไม่ต้องเปิดบัญชีเพิ่มบริษัทสามารถอนุมัติผ่านระบบออนไลน์ได้รวดเร็วทำให้พนักงานได้รับเงินทันเวลา
                            </span>
                        </Row>
                    </Row>
                    <Space direction="vertical" style={{ textAlign: "center" }}>
                        <Button onClick={() => serviceCreditRemainder()} style={{
                            backgroundColor: "#FF9401",
                            color: "white",
                            height: isPortrait ? "4vh" : "4vw"
                            , width: isPortrait ? "30vh" : "40vw",
                            fontSize: isPortrait ? "1.8vh" : "1.8vw",
                            borderRadius: isPortrait ? "2vh" : "4vh",
                            borderColor: "#FF9401",
                        }}>
                            <span>สมัครเบิกเงินล่วงหน้า</span>
                        </Button>
                    </Space>
                </Flex>
            </Drawer>
        )
    }


    return {
        h1,
        h2,
        product,
        card,
        navBar,
        drawer,

    }
}
export default useProduct;